<script lang="ts">
import { useUserProfileStore } from "@/store/userProfile";
import LanguageDropDown from "./LanguageDropDown.vue";
import { userService } from "@/services/serviceProvider";
import userDummy from '@/assets/images/users/user-dummy-black.png';

export default {
  components: {
    LanguageDropDown
  },
  data() {
    const stateUserProfile = useUserProfileStore();
    stateUserProfile.loadProfile();
    const user = stateUserProfile.profile;
    return {
      user,
      userImageDummy: userDummy
    };
  },
  methods: {
    editProfile() {
      window.open(userService.editProfileUrl, '_blank');
    }
  },
};
</script>
<template>
  <v-menu>
    <template v-slot:activator="{ props }">
      <a dark v-bind="props" class="d-flex align-center justify-space-between w-100">
        <div class="d-flex align-center px-2 w-100">
          <v-avatar size="32" class="user-profile mr-2">
            <v-img class="header-profile-user" :src="userImageDummy" alt="Header Avatar" />
          </v-avatar>
          <span class="text-start ms-xl-3" style="line-height: 19px;">
            <h4 v-if="user.userType != 'StakeHolder'" class="d-xl-inline-block user-name-text font-weight-medium">
              {{ user.displayName }}
            </h4>
            <h4 v-else class="d-xl-inline-block user-name-text font-weight-medium">
              {{ user.email }}
            </h4>
            <span v-if="user.userType === 'Internal'" class="d-xl-block user-name-sub-text">{{ $t('t-department') }} {{
              user.department }}</span>
            <!-- <span v-else class="d-xl-block user-name-sub-text">{{ user.jobTitle }}</span> -->
          </span>
        </div>
        <div class="mx-1 px-0">
          <v-icon icon="mdi mdi-chevron-down"></v-icon>
        </div>
      </a>
    </template>
    <v-list density="compact" :lines="false" class="profile-list" nav>
      <div v-if="$vuetify.display.xs">
        <h6 v-if="user.userType != 'StakeHolder'" class="dropdown-header pl-1 pb-0">
          {{ user.displayName }}
        </h6>
        <h6 v-else class="dropdown-header pl-1 pb-1">
          {{ user.email }}
        </h6>
        <span v-if="user.userType === 'Internal'" class="dropdown-header pl-1">{{ $t('t-department') }} {{
          user.department }}</span>
        <v-divider class="my-2" style="opacity: 0.05;"></v-divider>
        <div class="dropdown dropdown-language">
          <LanguageDropDown />
        </div>
        <v-divider class="my-2" style="opacity: 0.05;"></v-divider>
      </div>
      <!-- TODO: active this when smart platform ready -->
      <!-- <v-list-item class="dropdown-item" @click="editProfile">
        <i class="mdi mdi-account-circle text-muted" />
        {{ $t('t-profile') }}
      </v-list-item> -->
      <v-list-item class="dropdown-item" @click="" to="/logout">
        <i class="mdi mdi-logout text-muted" />
        <span class="align-middle" data-key="t-logout">{{ $t('t-logout') }}</span>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
